<template>
  <div>
    <Header navTitle="案件列表" navTip="公司当前进行中案件列表，你可由此进入工时填报"></Header>
    <div class="caseBox">
      <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
        <van-list
          style="height: calc(100% - 200px)"
          :loading="state.loading"
          :finished="state.finished"
          :offset="10"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <template v-for="item in state.list" :key="item">
            <ActiveList
              :nav="`${item.finalCustomer}/${item.caseType}/${
                item.time.split(' ')[0]
              }/${item.caseStatusName}`"
              :title="item.caseName"
              :time="item.countHour"
              @click="onJump(item.planId, item.id, item.caseStatus)"
            ></ActiveList>
          </template>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script lang="ts">
import Header from '@/components/header.vue';
import { defineComponent, reactive, ref } from 'vue';
import ActiveList from '@/components/ActiveList.vue';
import { List, PullRefresh, Toast } from 'vant';
import { useRouter, useRoute } from 'vue-router';
import getList from '@/http/castList';

export default defineComponent({
  components: {
    ActiveList,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    Header,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    });
    const pages = reactive({
      pageNo: 0,
      pageSize: 6,
      type: 1,
    });
    // 跳转
    const onJump = (id: string, pro: string, status: string) => {
      router.push({
        path: '/caseForm',
        query: { projectId: pro, type: 2, status },
      });
    };
    const onLoad = () => {
      console.log('11');
      state.loading = true;
      state.finished = false;
      pages.pageNo += 1;
      getList(pages).then((res: any) => {
        const { total } = res.result;
        const data: [] = res.result.records;
        state.refreshing = false;
        state.list.push(...data);
        state.loading = false;
        if (state.list.length === total) {
          state.finished = true;
        }
      });
    };
    const onRefresh = () => {
      state.list = [];
      pages.pageNo = 0;
      onLoad();
    };
    return {
      state,
      onLoad,
      onJump,
      onRefresh,
    };
  },
});
</script>

<style lang="scss" scoped>
/deep/.ng {
  .van-calendar__bottom-info {
    background: red;
    width: 25px;
    margin: auto;
    border-radius: 20px;
    bottom: 3px;
    color: #fff;
  }
}
.caseBox {
  margin-top: 20px;
  padding: 0 10px;
  height: calc(100vh - 200px);
  overflow: auto;
}
</style>
